import React from 'react';
import { RetryPanel } from '../retry-panel/retry-panel';
import styles from './with-retry-panel.scss';

interface Props {
  failed: number;
  canceled: number;
  onRetryAllClick(): void;
  children: any;
}

export const WithRetryPanel: React.FunctionComponent<Props> = ({
  failed,
  canceled,
  onRetryAllClick,
  children,
}: Props) => {
  return (
    <div className={styles.withRetryPanel}>
      {failed + canceled > 0 ? (
        <RetryPanel
          className={styles.retryPanel}
          canceledCount={canceled}
          failedCount={failed}
          onRetryAllClick={onRetryAllClick}
        />
      ) : null}
      <div className={styles.body}>{children}</div>
    </div>
  );
};
